export default __webpack_public_path__ + "static/media/Smart_plug_Total_KWh.6e8bbd26.svg";